export const ResultsPerMonthColumns = [
    { header: "Year", accessor: "year" },
    { header: "Month", accessor: "month" },
    {
      header: "Campaigns",
      accessor: "campaigns",
      total_key: "total_campaigns",
    },

    {
      header: "Shipped",
      accessor: "shippedQty",
      total_key: "total_shippedQty",
    },
    { header: "Mailed", accessor: "mailedQty", total_key: "total_mailedQty" },
    { header: "ROR%", accessor: "rorper", total_key: "total_rorper" },
    {
      header: "Mail Orders",
      accessor: "mailOrders",
      total_key: "total_MailOrders",
    },
    {
      header: "Phone Orders",
      accessor: "phoneOrders",
      total_key: "total_PhoneOrders",
    },
    {
      header: "Web Orders",
      accessor: "webOrders",
      total_key: "total_WebOrders",
    },
    {
      header: "Back Orders",
      accessor: "backOrders",
      total_key: "total_BackOrders",
    },
    { header: "Orders", accessor: "Gross_Orders", total_key: "total_orders" },
    { header: "Cost", accessor: "totalCost", total_key: "total_totalCost" },
    { header: "Sales", accessor: "grossSales", total_key: "total_grossSales" },
    { header: "NetSales", accessor: "netSales", total_key: "total_netSales" },
    {
      header: "Refunds Count",
      accessor: "refunds_count",
      total_key: "total_refunds_count",
    },
    {
      header: "Refund rate%",
      accessor: "refundRatePercent",
      total_key: "total_refundRatePercent",
    },
    { header: "Refunds", accessor: "refunds", total_key: "total_refunds" },
    { header: "Profit", accessor: "profit", total_key: "total_profit" },
    { header: "%PL", accessor: "PLper", total_key: "total_PLper" },
    { header: "PL/Client", accessor: "plClient", total_key: "total_plClient" },
    { header: "PL/Mail", accessor: "plMail", total_key: "total_plMail" },
    {
      header: "Turnover/Mail",
      accessor: "turnoverMail",
      total_key: "total_turnoverMail",
    },
    { header: "Cost/Mail", accessor: "costMail", total_key: "total_costMail" },
    { header: "Be Mlg Qty", accessor: "beMlgQty", total_key: "total_beMlgQty" },
    {
      header: "Be Orders",
      accessor: "be_orders",
      total_key: "total_be_orders",
    },
    {
      header: "LTV FE P/L per Buyer",
      accessor: "fe_p_l_ltv1",
      total_key: "total_fe_p_l_ltv1",
    },
    {
      header: "LTV BE PL per Buyer",
      accessor: "ltv_be_pl_per_buyer",
      total_key: "total_ltv_be_pl_per_buyer",
    },
    {
      header: "LTV Net PL per Buyer",
      accessor: "ltv_net_pl_per_buyer",
      total_key: "total_ltv_net_pl_per_buyer",
    },]